import { SegmentIndustry } from '../../../../models/measure/report';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { pieChartConfig, chartConfig } from '../../../app.constants';
var IndustryDrillDownReportComponent = /** @class */ (function () {
    function IndustryDrillDownReportComponent(pdfService) {
        this.pdfService = pdfService;
        this.industryPieChartData = [];
        this.industryLineData = [];
        this.loadPieChartStyling();
    }
    IndustryDrillDownReportComponent.prototype.ngOnInit = function () {
        this.industryPieChartData = this.segementIndustry.pieChart.map(function (pie) { return ({
            name: pie.name,
            y: pie.value
        }); });
        this.industryLineData = this.segementIndustry.barChart.map(function (line) { return ({
            name: line.name,
            y: line.value
        }); });
    };
    IndustryDrillDownReportComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(IndustryDrillDownReportComponent.COMPONENT_NAME);
    };
    Object.defineProperty(IndustryDrillDownReportComponent.prototype, "haveNoData", {
        get: function () {
            if (!this.segementIndustry) {
                return true;
            }
            return this.segementIndustry.barChart.length === 0
                && this.segementIndustry.pieChart.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    IndustryDrillDownReportComponent.prototype.loadPieChartStyling = function () {
        this.chartHeight = chartConfig.industryDrillDownChart.chartHeight;
        this.chartInnerSize = pieChartConfig.pdfView.pieChartInnerSize;
        this.chartTitleStyling = chartConfig.industryDrillDownChart.titleStyling;
        this.chartLegend = chartConfig.industryDrillDownChart.chartLegend;
    };
    IndustryDrillDownReportComponent.COMPONENT_NAME = 'IndustryDrillDownReportComponent';
    return IndustryDrillDownReportComponent;
}());
export { IndustryDrillDownReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/industry-drill-down-report/industry-drill-down-report.component.ts.pre-build-optimizer.js